import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-accordion',
  styleUrl: 'lab-ds-accordion.css',
  shadow: true,
})
export class LabDsAccordion {
  @Prop() titleAccordion: string;

  @Prop() descriptionAccordion: string;

  @Prop() titlePanel?: string;

  @Prop() bodyPanel?: string;

  @Prop() icon: string;

  @Prop() openAccordion: boolean = false;

  @Prop() disabled: boolean = false;

  render() {
    return (
      <div class={`v4-accordion ${this.openAccordion ? 'open' : 'closed'} ${this.disabled ? 'disabled' : ''}`}>
        <div
          tabIndex={1}
          onClick={() => {
            if (this.disabled) return;

            this.openAccordion = !this.openAccordion;
          }}
          class="v4-accordion-header-description"
        >
          <div class="v4-accordion-header">
            <div class="v4-accordion-title">
              {this.icon && <lab-ds-icon-not-selectable icon={this.icon} size="medium" />}
              <span class="v4-accordion-title-text">{this.titleAccordion}</span>
            </div>
            <lab-ds-icon-not-selectable class="action-icon" icon={!this.openAccordion ? 'expand_more' : 'expand_less'} size="s-medium" />
          </div>
          {this.descriptionAccordion && !this.openAccordion && <div class="v4-accordion-description">{this.descriptionAccordion}</div>}
        </div>
        {this.openAccordion && (
          <div class="v4-accordion-content">
            <slot name="body-accordion"></slot>
            {this.titlePanel && <div class="v4-accordion-content-title">{this.titlePanel}</div>}
            {this.bodyPanel && <div class="v4-accordion-content-body">{this.bodyPanel}</div>}
          </div>
        )}
      </div>
    );
  }
}
